import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {Elements, StripeProvider} from 'react-stripe-elements';
import CheckoutForm from './CheckoutForm';

import './CreateAnEnterpriseSubscriptionCCForm.css';

var pf_config = require('../../pf_config.json');

class CreateAnEnterpriseSubscriptionCCForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    price: PropTypes.number.isRequired
  }

  constructor(props){
    super(props);
  }

  render(){
    return (
      <div className="stripe-cc-form flex-grow-1">
        <StripeProvider apiKey={process.env.REACT_APP_STRIPE_KEY}>
          <Elements>
            <CheckoutForm onSubmit={this.props.onSubmit} price={this.props.price}/>
          </Elements>
        </StripeProvider>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {  } = state;

  return {
    
  }
}

export default connect(mapStateToProps)(CreateAnEnterpriseSubscriptionCCForm);



// WEBPACK FOOTER //
// ./src/components/CreateAnEnterpriseSubscriptionCCForm/CreateAnEnterpriseSubscriptionCCForm.js